import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { ControlLabel, FormGroup, HelpBlock } from "react-bootstrap";
import Datetime from "react-datetime";
import "../../../../node_modules/react-datetime/css/react-datetime.css";
import moment from "moment";
import "moment/locale/fr-ca";
import "moment/locale/en-ca";

class DayPicker extends React.Component {
  validDate(currentDate) {
    const { minDate, maxDate } = this.props;
    if (minDate && maxDate) {
      return currentDate.isBetween(minDate, maxDate, undefined, "[]");
    } else if (minDate) {
      return currentDate.isSameOrAfter(minDate);
    } else if (maxDate) {
      return currentDate.isBefore(maxDate);
    }
    return currentDate.year() >= 1900;
  }

  render() {
    const {
      dateFormat,
      input,
      label,
      meta: { touched, error, warning },
      groupClassName,
      id,
      overrideState,
      onBlur,
      viewMode,
      required,
      onChangeFunc,
      placeholder,
      optionalWidth, // Allows us to pass a width to the datetime field.
      hintKey,
      ...rest
    } = this.props;

    let validationState = touched && !!error ? error.state || "error" : null;
    let validationMessageKey =
      !!error && error.messageKey ? error.messageKey : "error.unknown";
    let validationValues = !!error && error.values ? error.values : {};

    if (touched && !!warning) {
      /**
       * Allows us to display error on field, but also make the request to the api. With the error option, no api call is made.
       */
      validationState = warning.state;
      validationMessageKey = warning.messageKey;
      validationValues = warning.values ? warning.values : {};
    }

    const scene = this.context.scene ? "-" + this.context.scene : "";
    const date = moment.isMoment(input.value)
      ? input.value
      : moment(input.value); // (/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d{3})?Z$/.test(input.value)) ? moment(input.value) : input.value;
    const validDate = (currentDate, selectedDate) =>
      this.validDate(currentDate) &&
      this.props.isValidDate(currentDate, selectedDate);
    const locale = this.props.locale;

    return (
      <FormGroup
        className={groupClassName}
        controlId={id + scene}
        validationState={overrideState || validationState}
      >
        {label && (
          <ControlLabel>
            {label}
            {required ? <span className="required"> *</span> : ""}
          </ControlLabel>
        )}
        <div
          className="input-wrapper"
          style={optionalWidth ? { width: optionalWidth } : null}
          onKeyPress={this.handleKeyPress}
        >
          <Datetime
            ref="picker"
            {...input}
            inputProps={{
              readOnly: true,
              className: "form-control datefield-nogrey",
              disabled: this.props.disabled,
              placeholder: placeholder,
            }}
            {...rest}
            dateFormat={dateFormat}
            value={date}
            timeFormat={false}
            viewMode={viewMode}
            isValidDate={validDate}
            onChange={(value) => {
              let e = {};
              e["target"] = {};
              e.target["name"] = input.name;
              e.target["value"] = value;
              onBlur && onBlur(e);

              if (onChangeFunc) {
                onChangeFunc(value);
              }
              return input.onChange(value);
            }}
            closeOnTab={true}
            utc={this.props.utc}
            locale={locale}
          />

          {((touched && error) || (touched && warning)) && (
            <HelpBlock>
              <FormattedMessage id={validationMessageKey} values={validationValues} />
            </HelpBlock>
          )}
          {hintKey && !((touched && error) || (touched && warning)) && (
            <HelpBlock className="daypicker-hint">
              <strong>
                <FormattedMessage id="hint" />{" "}
              </strong>
              <FormattedMessage id={hintKey} />
            </HelpBlock>
          )}
        </div>
      </FormGroup>
    );
  }
}

DayPicker.propTypes = {
  dateFormat: PropTypes.string,
  disabled: PropTypes.bool,
  groupClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  input: PropTypes.object.isRequired,
  isStatic: PropTypes.bool,
  isValidDate: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  meta: PropTypes.object.isRequired,
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  width: PropTypes.number,
  optionalWidth: PropTypes.string,
  locale: PropTypes.string,
  required: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onChangeFunc: PropTypes.func,
  overrideState: PropTypes.string,
  placeholder: PropTypes.string,
  hintKey: PropTypes.string,
  showClearButton: PropTypes.bool,
  validation: PropTypes.object,
  validationKey: PropTypes.string,
  calendarPlacement: PropTypes.string,
  utc: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  viewMode: PropTypes.string,
};

DayPicker.defaultProps = {
  dateFormat: "DD/MM/YYYY",
  isValidDate: () => true,
  utc: true,
  viewMode: "years",
  hintKey: null,
};

DayPicker.contextTypes = {
  scene: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    locale: state.auth.user ? state.auth.user.languageCode : state.intl.locale,
  };
}

export default connect(mapStateToProps)(DayPicker);



// WEBPACK FOOTER //
// ./src/components/common/form/DayPicker.js